"use client";

import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { CheckCircle, HelpCircle, XCircle } from "lucide-react";
import type { InvoiceItem } from "./types";

interface NcmStatusBadgeProps {
  invoiceItem: InvoiceItem;
}

export function NcmStatusBadge({ invoiceItem }: NcmStatusBadgeProps) {
  if (!invoiceItem.ncmSt) {
    return (
      <div className="flex items-center gap-2 w-full justify-between">
        <Badge variant="secondary" className="text-xs">
          Nao vinculado
        </Badge>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <HelpCircle className="h-3 w-3 text-muted-foreground cursor-help" />
            </TooltipTrigger>
            <TooltipContent className="max-w-xs">
              <p>Este NCM nao possui vinculacao com nosso banco de dados.</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    );
  }

  const isActive = invoiceItem.ncmSt.is_active;

  return (
    <div className="flex items-center justify-between w-full gap-2">
      <Badge variant={isActive ? "default" : "destructive"} className="text-xs flex items-center gap-1">
        {isActive ? <CheckCircle className="h-3 w-3" /> : <XCircle className="h-3 w-3" />}
        {isActive ? "Ativo" : "Inativo"}
      </Badge>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <HelpCircle className="h-3 w-3 text-muted-foreground cursor-help" />
          </TooltipTrigger>
          <TooltipContent className="max-w-xs">
            <p>
              {isActive
                ? "Este NCM esta ativo em nosso banco de dados."
                : "Este NCM esta inativo. Pode ter sido desativado ou nao existia em nosso banco quando este item foi criado."}
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
